import { DueDateTagComponent } from './due-date-tag.component';

export default angular
  .module('sfMobile.components.due-date-tag', [])
  .component('sfDueDateTag', DueDateTagComponent).name;
